const categories = [
  {
    name: 'Corporate Classic',
    color: 'bg-blue-500',
    words: ['Synergy', 'Circle back', 'Leverage', 'Bandwidth', 'Low-hanging fruit', 'Move the needle'],
  },
  {
    name: 'Tech Startup',
    color: 'bg-purple-500',
    words: ['Pivot', 'Disrupt', 'Scale', 'Runway', 'MVP', 'Unicorn'],
  },
  {
    name: 'Agile/Scrum',
    color: 'bg-green-500',
    words: ['Sprint', 'Backlog', 'Standup', 'Velocity', 'Retrospective', 'User story'],
  },
  {
    name: 'Management',
    color: 'bg-orange-500',
    words: ['Alignment', 'Stakeholder', 'Deliverable', 'KPI', 'Action items', 'Take offline'],
  },
  {
    name: 'Finance',
    color: 'bg-emerald-500',
    words: ['ROI', 'Margin', 'Forecast', 'Quarter', 'Bottom line', 'Value-add'],
  },
]

const WordPools = () => {
  return (
    <section id="categories" className="section bg-gray-50">
      <div className="container-wide">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Buzzword Categories
          </h2>
          <p className="text-lg text-gray-600">
            Curated word pools for every type of meeting. From corporate all-hands to startup pitches.
          </p>
        </div>

        {/* Categories */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category) => (
            <div
              key={category.name}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-3 h-3 rounded-full ${category.color}`}></div>
                <h3 className="font-semibold text-gray-900">{category.name}</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {category.words.map((word) => (
                  <span
                    key={word}
                    className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full"
                  >
                    {word}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Teaser */}
        <div className="mt-12 text-center">
          <p className="text-gray-500">
            Custom word pools coming soon - create your own for team-specific jargon
          </p>
        </div>
      </div>
    </section>
  )
}

export default WordPools
